import { render } from "./queueComponent.vue?vue&type=template&id=8ae655aa"
import script from "./queueComponent.vue?vue&type=script&lang=js"
export * from "./queueComponent.vue?vue&type=script&lang=js"

import "./queueComponent.vue?vue&type=style&index=0&id=8ae655aa&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__